__turbopack_context__.v({
  "actions": "Header-module-scss-module__t7BEda__actions",
  "burger": "Header-module-scss-module__t7BEda__burger",
  "burgerOpen": "Header-module-scss-module__t7BEda__burgerOpen",
  "cartButton": "Header-module-scss-module__t7BEda__cartButton",
  "cartCount": "Header-module-scss-module__t7BEda__cartCount",
  "cartIcon": "Header-module-scss-module__t7BEda__cartIcon",
  "chevron": "Header-module-scss-module__t7BEda__chevron",
  "chevronOpen": "Header-module-scss-module__t7BEda__chevronOpen",
  "desktopNav": "Header-module-scss-module__t7BEda__desktopNav",
  "dropIn": "Header-module-scss-module__t7BEda__dropIn",
  "dropdown": "Header-module-scss-module__t7BEda__dropdown",
  "dropdownItem": "Header-module-scss-module__t7BEda__dropdownItem",
  "dropdownMenu": "Header-module-scss-module__t7BEda__dropdownMenu",
  "dropdownTrigger": "Header-module-scss-module__t7BEda__dropdownTrigger",
  "header": "Header-module-scss-module__t7BEda__header",
  "inner": "Header-module-scss-module__t7BEda__inner",
  "logo": "Header-module-scss-module__t7BEda__logo",
  "menuToggle": "Header-module-scss-module__t7BEda__menuToggle",
  "mobileDropdown": "Header-module-scss-module__t7BEda__mobileDropdown",
  "mobileDropdownItem": "Header-module-scss-module__t7BEda__mobileDropdownItem",
  "mobileDropdownMenu": "Header-module-scss-module__t7BEda__mobileDropdownMenu",
  "mobileDropdownMenuOpen": "Header-module-scss-module__t7BEda__mobileDropdownMenuOpen",
  "mobileDropdownTrigger": "Header-module-scss-module__t7BEda__mobileDropdownTrigger",
  "mobileLangPicker": "Header-module-scss-module__t7BEda__mobileLangPicker",
  "mobileNav": "Header-module-scss-module__t7BEda__mobileNav",
  "mobileNavLink": "Header-module-scss-module__t7BEda__mobileNavLink",
  "mobileNavOpen": "Header-module-scss-module__t7BEda__mobileNavOpen",
  "navLink": "Header-module-scss-module__t7BEda__navLink",
  "themeToggle": "Header-module-scss-module__t7BEda__themeToggle",
});
